import React, { useEffect, useState } from 'react'
import type { Control, FieldValues, RegisterOptions, FieldErrors } from 'react-hook-form'
import YearRangePicker from '../YearRangePicker'

type DateRangeValue = [Date | null, Date | null]

interface DateRangePickerProps {
  name: string
  onChange: (value: DateRangeValue) => void
  Controller: React.ComponentType<any>
  control: Control<FieldValues>
  rules?: RegisterOptions
  errors: FieldErrors
  className?: string
  containerClass?: string
  value?: DateRangeValue
}

function DateRangePicker(props: DateRangePickerProps) {
  const { onChange: onChangeProp, value: valueProp, ...rest } = props
  const [value, setValue] = useState<DateRangeValue>(valueProp || [null, null])

  // Sync with parent value prop when it changes
  useEffect(() => {
    if (valueProp) {
      const [from, to] = valueProp
      const [currentFrom, currentTo] = value
      if (from?.getTime() !== currentFrom?.getTime() || to?.getTime() !== currentTo?.getTime()) {
        setValue(valueProp)
      }
    }
  }, [valueProp]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (newValue: DateRangeValue) => {
    setValue(newValue)
    onChangeProp(newValue)
  }

  return <YearRangePicker {...rest} onChange={handleChange} value={value} />
}

export default DateRangePicker
